<!--================================
=            TABLEBASIC            =
=================================-->
<template>
  <!-- page blank -->
  <div>
    <v-row >
      <base-header>
        <div slot="page-header">Table Basic</div>
      </base-header>
    </v-row>

    <v-row >
      <v-col class="col-12 col-md-6 col-sm-12">
        <base-card >
          <div slot="card-header">Table head</div>
           <div slot="card-subheader">The simple table is a wrapper component around the  element.</div>
          <div slot="card-body">
            <v-simple-table  :class="$vuetify.theme.dark ? 'card-light' : 'card-light'">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      Calories
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in desserts" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td>{{ item.calories }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </base-card>
      </v-col>
      <v-col class="col-12 col-md-6 col-sm-12">
        <base-card >
          <div slot="card-header">Dark table</div>
           <div slot="card-subheader">Use dark prop to switch table to the dark theme.</div>
          <div slot="card-body">
            <v-simple-table   dark>
              <template v-slot:default>
                <thead dark>
                  <tr>
                    <th class="white--text text-left">
                      Name
                    </th>
                    <th class=" white--texttext-left">
                      Calories
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in desserts" dark :key="item.name">
                    <td class="white--text">{{ item.name }}</td>
                    <td class="white--text">{{ item.calories }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </base-card>
      </v-col>
    
       <v-col class="col-12 col-md-6 col-sm-12">
        <base-card >
          <div slot="card-header">Bordered table</div>
           <div slot="card-subheader">Use the height prop to set the height of the table.</div>
          <div slot="card-body">
            <v-simple-table  :class="$vuetify.theme.dark ? 'card-light' : 'card-light'" fixed-header height="300px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      Calories
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in desserts" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td>{{ item.calories }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </base-card>
      </v-col>
      <v-col class="col-12 col-md-6 col-sm-12">
        <base-card >
          <div slot="card-header">Borderless table</div>
           <div slot="card-subheader">You can show a dense version of the table by using the dense prop.</div>
          <div slot="card-body">
            <v-simple-table  :class="$vuetify.theme.dark ? 'card-light' : 'card-light'" height="300px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      Calories
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in desserts" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td>{{ item.calories }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </base-card>
      </v-col>
    </v-row>

  </div>
</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from "../../components/Base/BaseHeader.vue";

  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data() {
      return {
        desserts: [{
            name: 'Frozen Yogurt',
            calories: 159,
          },
          {
            name: 'Ice cream sandwich',
            calories: 237,
          },
          {
            name: 'Eclair',
            calories: 262,
          },
          {
            name: 'Cupcake',
            calories: 305,
          },
          {
            name: 'Gingerbread',
            calories: 356,
          },
          {
            name: 'Jelly bean',
            calories: 375,
          },
         
        ],

      }
    }
  };
</script>
<!--====  End of TABLEBASIC  ====-->